import { cva } from 'class-variance-authority';

export const sliderRootClasses =
  'scrollbar-hide relative w-full snap-x snap-mandatory overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden';

export const getSliderRootStyle = (desktopVisible: number, mobileVisible: number) => {
  const calculateBasis = (visible: number) =>
    visible === 1 ? '100%' : `calc((100% - ${8 * (visible - 1)}px) / ${visible})`;

  return {
    '--slider-gap': '8px',
    '--slider-item-basis-mobile': calculateBasis(mobileVisible),
    '--slider-item-basis-desktop': calculateBasis(desktopVisible)
  } as React.CSSProperties;
};

export const sliderTrackClasses = cva([
  'flex [&>*]:shrink-0 [&>*]:basis-[var(--slider-item-basis-mobile)] [&>*]:pr-[var(--slider-gap)]',
  'lg:[&>*]:basis-[var(--slider-item-basis-desktop)]'
]);

export const sliderItemClasses = 'snap-start transition-transform duration-300 ease-in-out';
